import { Instagram, MessageCircle, Phone } from "lucide-react";
import { BRAND } from "@/lib/site";
import { scrollToId } from "@/lib/scroll";
import OpenStatus from "@/components/OpenStatus";

const LINKS = [
  { label: "Rituals", href: "#services" },
  { label: "Sanctuary", href: "#sanctuary" },
  { label: "Reviews", href: "#reviews" },
  { label: "Book Now", href: "#booking" },
  { label: "Visit Us", href: "#visit" },
];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-magenta/15 bg-plum-900/40 pb-28 md:pb-12"
    >
      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-14 sm:grid-cols-2 lg:grid-cols-4 lg:px-10">
        <div className="sm:col-span-2 lg:col-span-1">
          <div className="flex items-center gap-3">
            <span className="grid h-11 w-11 place-items-center overflow-hidden rounded-full bg-cream">
              <img
                src="/assets/logo-small.webp"
                alt="Orchid Vue Spa logo"
                className="h-9 w-9 object-contain"
              />
            </span>
            <span className="leading-none">
              <span className="block font-serif text-lg font-semibold text-cream">
                ORCHID VUE
              </span>
              <span className="mt-1 block font-mono text-[10px] uppercase tracking-[0.3em] text-[#EF7CC2]">
                Spa · Bur Dubai
              </span>
            </span>
          </div>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-lavender">
            {BRAND.tagline}. {BRAND.address}
          </p>
        </div>

        <nav aria-label="Footer">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#EF7CC2]">
            Explore
          </p>
          <ul className="mt-4 space-y-2.5">
            {LINKS.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  data-testid={`footer-link-${link.label.toLowerCase().replace(/\s/g, "-")}`}
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToId(link.href);
                  }}
                  className="text-sm text-lavender transition-colors duration-300 hover:text-cream"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#EF7CC2]">
            Contact
          </p>
          <ul className="mt-4 space-y-3">
            <li>
              <a
                data-testid="footer-call-link"
                href={BRAND.callLink}
                className="flex items-center gap-2.5 text-sm text-lavender transition-colors duration-300 hover:text-cream"
              >
                <Phone className="h-4 w-4 text-champagne" />
                {BRAND.phoneDisplay}
              </a>
            </li>
            <li>
              <a
                data-testid="footer-whatsapp-link"
                href={BRAND.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2.5 text-sm text-lavender transition-colors duration-300 hover:text-cream"
              >
                <MessageCircle className="h-4 w-4 text-wa" />
                WhatsApp Booking
              </a>
            </li>
            <li>
              <a
                data-testid="footer-instagram-link"
                href={BRAND.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2.5 text-sm text-lavender transition-colors duration-300 hover:text-cream"
              >
                <Instagram className="h-4 w-4 text-magenta" />
                @orchidvuespa
              </a>
            </li>
          </ul>
        </div>

        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#EF7CC2]">
            Hours
          </p>
          <p className="mt-4 text-sm text-lavender">{BRAND.hours}</p>
          <div className="mt-3">
            <OpenStatus compact />
          </div>
          <p className="mt-3 text-sm text-lavender">
            Advance booking on WhatsApp recommended.
          </p>
        </div>
      </div>

      <div className="mx-auto max-w-7xl border-t border-magenta/10 px-5 pt-8 lg:px-10">
        <p className="text-xs text-lavender/80">
          © {new Date().getFullYear()} {BRAND.legalName} · {BRAND.address}
        </p>
      </div>
    </footer>
  );
}
